
import React, { Component } from "react";
import { invokeApig } from "../libs/awsLib";
import { Segment, List} from 'semantic-ui-react'

export default class DataFlowViewer extends Component {
constructor(props)
{
  super(props);
  this.state={filecontent: '', isLoading: true}
}

loadDataFlow(flowtype, flowid) {
    
    //get view data    
    console.log(flowtype, flowid)
    invokeApig({path: '/dataflowhandler/' +  flowtype + 's/' +flowid , method: "GET",  body: null, queryParams: null}).then((results)=>{console.log(results);this.setState({filecontent: results.data.content, isLoading: false, selectedrow: null, selectedid: null})}).catch(err=>{console.log(err)})
    
  }

  componentDidMount()
  {
    const flowtype=this.props.flowtype;
    const flowid=this.props.flowid;
    this.loadDataFlow(flowtype, flowid);
  }
  componentWillReceiveProps(nextProps)
  {
    if(!(this.props.flowtype===nextProps.flowtype && this.props.flowid===nextProps.flowid))
    {
        const flowtype=nextProps.flowtype;
        const flowid=nextProps.flowid;
        this.loadDataFlow(flowtype, flowid);
        this.setState({isLoading: true})

    }
  }

  render() {
    return (
        <Segment basic>
        <List>
            {this.state.filecontent.split('\n').map(line=>{return <List.Item>{line}</List.Item>})}
        </List>
        </Segment>
    );
    }
  }
